import _ from 'lodash';

import * as constants from './PureModeCourse.constants';
import * as services from './PureModeCourse.service';

const state = {
  Course: {},
  lastRecord: {},
  isRequest: false,
};

const mutations = {
  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },

  [constants.GET_PURE_COURSE_SUCCESS](state, data) {
    if (data) {
      state.Course = data.Course[0];
      if (undefined !== data.lastRecord && null !== data.lastRecord) {
        state.lastRecord = data.lastRecord;
      }
    } else {
      state.Course = {};
    }
  },
};

const actions = {
  async getPureCourse({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getPureCourse(payload);
    commit(constants.GET_PURE_COURSE_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },
};

const getters = {
  Course: (state) => {
    const groups = _.map(state.Course.groups, (group) => {
      const books = _.map(group.books, (book) => {
        const isLockedByStudentWorkStatus =
          book.studentWorkEntity && 0 === book.studentWorkEntity.studentWorkStatus;
        const readings = _.map(book.readings, (reading) => {
          return {
            ...reading,
            c_isLockedByStudentWorkStatus: isLockedByStudentWorkStatus,
            c_isCanStudy: reading.canAccess && !isLockedByStudentWorkStatus,
          };
        });
        return {
          ...book,
          readings,
          c_isLockedByStudentWorkStatus: isLockedByStudentWorkStatus,
          c_isCanStudy: book.canAccess && !isLockedByStudentWorkStatus,
        };
      });
      return {
        ...group,
        books,
      };
    });
    return {
      ...state.Course,
      groups,
    };
  },

  lastRecord: (state) => state.lastRecord,
  isRequest: (state) => state.isRequest,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
